import { useState } from "react";
import { landingFaq } from "@/mocks/pricingPlans";
import { CONTACT } from "@/config/contact";
import Reveal from "@/components/site/Reveal";
import SectionTitle from "@/components/site/SectionTitle";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-28 bg-white py-20 md:py-28">
      <div className="mx-auto grid max-w-6xl gap-12 px-4 md:px-6 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
        <div>
          <SectionTitle eyebrow="FAQ" title="Les questions qu'on nous pose le plus" />
          <p className="mt-5 text-foreground-600">
            Une autre question ? Écrivez à{" "}
            <a href={`mailto:${CONTACT.email}`} className="font-medium text-primary-700 underline underline-offset-4 hover:text-primary-900">
              {CONTACT.email}
            </a>
            .
          </p>
        </div>

        <div className="divide-y divide-background-200 border-y border-background-200">
          {landingFaq.map((item, index) => {
            const isOpen = open === index;
            return (
              <Reveal key={item.q} delay={index * 50}>
                <div>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : index)}
                    className="flex w-full items-center justify-between gap-6 py-5 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className="text-base font-semibold font-heading text-foreground-950 md:text-lg">{item.q}</span>
                    <span
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors ${
                        isOpen ? "border-primary-950 bg-primary-950 text-white" : "border-background-300 text-foreground-700"
                      }`}
                      aria-hidden="true"
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  <div
                    className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="max-w-2xl pb-6 leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
